import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { configureApiClient } from "@hackereyes/api-client";

import { App } from "./app";
import "./index.css";

// Configure the generated SDK's singleton client BEFORE any component mounts.
// Sets baseUrl + credentials mode for every subsequent API call.
configureApiClient();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
